import { CreditScoreFactors } from "./ApplicantDataResponses/credit";
import { ClientLocation } from "./clientLocation";
import { HardDeclineReason } from "./hardDeclineReason";
import { ConditionalAcceptanceVerbiage, ScreeningLight } from "./screeningInvite";

export class AdverseActionLetter 
{
    screeningData: ScreeningLight;
    location: ClientLocation;
    creditBureau: CreditBureauInformation;
    creditScoreFactors: CreditScoreFactors[];
    conditionalVerbiage: ConditionalAcceptanceVerbiage[];
    hardDeclineReasons: HardDeclineReason[];
    cra: CraModelData;

    
    public get propertyConditionalVerbiage() : string {
        if(this.conditionalVerbiage && this.conditionalVerbiage.length > 0){
            var possible = this.conditionalVerbiage.find(cv =>{return cv.verbType == 1;});
            if(possible) return possible.verbiage;
        }
        return undefined;
    }

    
    public get riqConditionalVerbiage() : string {
        if(this.conditionalVerbiage && this.conditionalVerbiage.length > 0){
            var possible = this.conditionalVerbiage.find(cv =>{return cv.verbType == 0;});
            if(possible) return possible.verbiage;
        }
        return undefined;
    }
    
    
}

export class CreditBureauInformation 
{
    Name : string;
    Address : string;
    CityStateZip : string;
    Phone : string;
}

export class CraModelData 
{
    Name : string;
    Address1 : string;
    Address2 : string;
    City : string;
    State : string;
    Zip : string;
    Phone : string;
    Url : string;
}